import "./HealthInsights.module.css";
import Header from "@/reusable_sections/Header";
import InstituteNews from "./sections/InstituteNews";
import Footer from "@/reusable_sections/Footer";
export default function HealthInsightsPage() {
  return <div>
      <Header />
      <InstituteNews />
      
      <Footer />
    </div>;
}